export default __webpack_public_path__ + "static/media/serresgr-logo-300x77 (1).c894e816.png";